import { MultiLanguageString, SessionTrait, TraitValue } from 'types'
import { ISessionContext } from '../components/providers'

export function makeSelection(
  trait: TraitValue,
  groupTitle: MultiLanguageString,
  getLanguageValue: ISessionContext['getLanguageValue']
): SessionTrait {
  return {
    groupTitle: getLanguageValue(groupTitle),
    traitId: trait.id!,
    title: getLanguageValue(trait.title!),
  }
}

export function getSelectionIndex(selections: SessionTrait[], selection: SessionTrait) {
  return selections.findIndex(s => {
    if (s.groupTitle !== selection.groupTitle) return false
    return s.title === selection.title
  })
}
